import React from "react";
import Loaders from "./Images/Rolling.gif";
import { useMyContext } from './Provider/CommonProvider';

import loadings from "./Images/loading/gif_loading.gif";

const LoaderPage = () => {

  const { loadingGifVideo } = useMyContext()
  return (
    <div style={{
      position: "fixed",
      top: 0,
      left: 0,
      width: "100%",
      height: "100vh",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      // background: "rgba(255, 255, 255, 0.3)",
      // backdropFilter: "blur(12px)",
      // WebkitBackdropFilter: "blur(12px)",
      zIndex: 999999,
      transition: "all 0.3s ease-in-out"
    }}>
      <div style={{
        // background: "rgba(255, 255, 255, 0.8)",
        padding: "30px",
        borderRadius: "24px",
        // boxShadow: "0 10px 40px rgba(0, 0, 0, 0.1)",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "10px",
        // border: "1px solid rgba(255, 255, 255, 0.3)"
      }}>
        <img src={loadings} style={{ width: "120px", height: "120px", objectFit: "contain" }} alt="image-loader" />
        <p style={{ margin: 0, fontWeight: "600", color: "#555", fontSize: "15px", fontFamily: "'Poppins', sans-serif" }}>Processing...</p>
      </div>
    </div>
  );
};
export default LoaderPage;